import React, { useState } from "react";
import { Affix, Form, Button, Modal, Input, Alert } from "antd";
import { useNavigate } from "react-router-dom";
import { CheckOutlined, CloseOutlined, CommentOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";

import { requestToken } from "../../auth/AuthServices";
import HeaderFarms from "../../utils/header_farms";
import { Block, Confirm, Report } from "notiflix";
import API from "../../services";
import { getApprovalActorAccess } from "../../features/shared/utils/approvalAccess";

const ApprovalActions = ({ mainData, editNavigateUrl = null, canEditData = null, onCommentClick = () => { }, onApproveClick = () => { } }) => {

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isCancelModalVisible, setIsCancelModalVisible] = useState(false);
    const [isCommentModalVisible, setIsCommentModalVisible] = useState(false);
    
    const [currentSession] = useState(
        JSON.parse(localStorage.getItem("session_farms"))
    );

    const navigate = useNavigate();

    if (!mainData) return null;

    const { approval_process_id } = mainData;
    const { data } = approval_process_id;
    const approvalAccess = getApprovalActorAccess(data, currentSession.employee_id);
    const canApprove = data.status !== "Reject" && approvalAccess.canApprove;

    const status = data?.status;
    const isRequestor = mainData?.employee_id && (mainData.employee_id === currentSession.employee_id);
    const canCancel = (status === "Waiting Approval" || status === "Approved") && !!isRequestor;

    const canComment =
        data.status !== "Reject" && (
            approvalAccess.isApprover ||
            approvalAccess.isDeputy ||
            approvalAccess.isPic ||
            isRequestor
        );

    const isEditAllowed = typeof canEditData === "boolean" ? canEditData : canApprove;

    if (!canApprove && !canCancel && !canComment) return null;

    const showModal = () => setIsModalVisible(true);
    const handleCancel = () => setIsModalVisible(false);
    const showCancelModal = () => setIsCancelModalVisible(true);
    const handleCancelCancel = () => setIsCancelModalVisible(false);
    const showCommentModal = () => {
        if (onCommentClick) {
            onCommentClick();
        }
        setIsCommentModalVisible(true);
    };
    const handleCommentCancel = () => setIsCommentModalVisible(false);


    const getApprovalDetailId = (mainData) => {
        if (!mainData) return null;

        const approvalProcessDetail = mainData.approval_process_id.data;
        return getApprovalActorAccess(approvalProcessDetail, currentSession.employee_id).approvalDetailId;
    };

    // 🔹 Logic approve
    const handleApprove = async () => {
        try {

            Block.dots(".ant-collapse");

            const idApprovalDetail = getApprovalDetailId(mainData, currentSession);

            if (!idApprovalDetail) {
                Report.warning(
                    "Oops.. something wrong",
                    "Please check approval status, maybe already approve",
                    "Okay"
                );

                Block.remove(".ant-collapse");
                return;
            }

            const accessToken = await requestToken();
            await API.ApprovalApproved(HeaderFarms(accessToken), { id: idApprovalDetail });

            Report.success(
                `Approved Success`,
                `Berhasil disetujui`,
                "Okay",
                function () {
                    if (onApproveClick && typeof onApproveClick === "function") {
                        onApproveClick();
                        return;
                    }
                    navigate("/wf/pending");
                }
            );

            Block.remove(".ant-collapse");

        } catch (err) {
            Block.remove(".ant-collapse");
            console.error(err);
            Report.warning(
                "Oops.. something wrong",
                "Sorry, this application is experiencing problems",
                "Okay"
            );
        }
    };

    // 🔹 Logic reject
    const handleReject = async (values) => {
        try {

            Block.dots(".ant-collapse");

            const idApprovalDetail = getApprovalDetailId(mainData, currentSession);

            if (!idApprovalDetail) {
                Report.warning(
                    "Oops.. something wrong",
                    "Please check approval status, maybe already approve",
                    "Okay"
                );
                Block.remove(".ant-collapse");
                return;
            }

            const accessToken = await requestToken();

            await API.ApprovalReject(HeaderFarms(accessToken), {
                id: idApprovalDetail,
                reason: values.message,
            });

            Report.success(
                `Rejected Success`,
                `Berhasil ditolak`,
                "Okay",
                function () {
                    if (onApproveClick && typeof onApproveClick === "function") {
                        onApproveClick();
                        return
                    }
                    navigate("/wf/pending");
                }
            );

            Block.remove(".ant-collapse");

        } catch (err) {

            Block.remove(".ant-collapse");
            console.error(err);
            Report.warning("Oops.. Something wrong", "Failed Rejected", "Okay");
        }
    };

    // dY"1 Logic cancel (requestor)
    const cancel = async (values) => {
        try {
            Block.dots(".ant-collapse");

            setIsCancelModalVisible(false);

            const approvalId = approval_process_id?.data?._id;
            if (!approvalId) {
                Report.warning(
                    "Oops.. something wrong",
                    "Unable to find approval id",
                    "Okay"
                );
                return;
            }

            const accessToken = await requestToken();
            await API.ApprovalCancel(HeaderFarms(accessToken), {
                id: approvalId,
                reason: values.message,
            });

            Report.success(
                `Cancel Success`,
                `Berhasil dibatalkan`,
                "Okay",
                function () {
                    if (onApproveClick && typeof onApproveClick === "function") {
                        onApproveClick();
                        return;
                    }
                    navigate("/wf/pending");
                }
            );

            Block.remove(".ant-collapse");

        } catch (err) {
            Block.remove(".ant-collapse");
            console.error(err);
            Report.warning(
                "Oops.. something wrong",
                "Sorry, this application is experiencing problems",
                "Okay"
            );
        }
    };

    const handleCancelSubmit = async (values) => {
        Confirm.show(
            "Important Confirmation",
            "Are you sure ?",
            "Yes",
            "No",
            () => {
                cancel(values);
            }
        );
    };

    // 🔹 Logic comment
    const handleComment = async (values) => {
        try {
            Block.dots(".ant-collapse");

            setIsCommentModalVisible(false);

            const formSubmitId = mainData.record_id || mainData.id_record || mainData.form_record;
           
            if (!formSubmitId) {
                Report.warning(
                    "Oops.. something wrong",
                    "Unable to find form submit id",
                    "Okay"
                );
                return;
            }

            const accessToken = await requestToken();
            await API.postComment(HeaderFarms(accessToken), {
                form_submit_id: formSubmitId,
                text_plain: values.message,
                employeeId: currentSession.employee_id,
            });

            Report.success(
                `Comment Posted`,
                `Comment complete sended`,
                "Okay", () => window.location.reload()
            );

            Block.remove(".ant-collapse");

        } catch (err) {
            Block.remove(".ant-collapse");
            console.error(err);
            Report.warning(
                "Oops.. something wrong",
                "Sorry, this application is experiencing problems",
                "Okay"
            );
        }
    };

    return (
        <>
            <div className="row mt-4">
                <div className="col-md-12">
                    <Affix offsetBottom={30}>
                        <Form.Item className="text-center" style={{ marginTop: 10 }}>
                            {canApprove && (
                                <>
                                {isEditAllowed && (mainData?.id_record || mainData?.record_id) && (
                                        <Button
                                            type="default"
                                            icon={<EditOutlined />}
                                            onClick={() =>
                                                navigate(editNavigateUrl ?? `/pa/edit/${mainData.record_id || mainData.id_record}`)
                                            }
                                            className="m-2"
                                            size="middle"
                                            style={{ minWidth: 120, borderRadius: 20 }}
                                        >
                                            Edit Data
                                        </Button>
                                    )}
                                    <Button
                                        type="primary"
                                        icon={<CheckOutlined />}
                                        onClick={() => {
                                            Confirm.show(
                                                "Important Confirmation",
                                                "Are you sure ? please make sure is correct.",
                                                "Yes",
                                                "No",
                                                () => {
                                                    handleApprove()
                                                }
                                            );
                                        }}
                                        className="m-2"
                                        size="middle"
                                        style={{ minWidth: 100, borderRadius: 20 }}
                                    >
                                        Approved
                                    </Button>
                                    <Button
                                        type="danger"
                                        icon={<CloseOutlined />}
                                        size="middle"
                                        onClick={showModal}
                                        className="m-2"
                                        style={{ minWidth: 100, borderRadius: 20 }}
                                    >
                                        Reject
                                    </Button>
                                </>
                            )}
                            {canCancel && (
                                <Button
                                    type="warning"
                                    icon={<StopOutlined />}
                                    className="m-2"
                                    size="middle"
                                    onClick={showCancelModal}
                                    style={{ minWidth: 100, borderRadius: 20 }}
                                >
                                    Cancel
                                </Button>
                            )}
                            {canComment && (
                                <>
                                    <Button
                                        type="default"
                                        icon={<CommentOutlined />}
                                        className="m-2"
                                        size="middle"
                                        onClick={showCommentModal}
                                        style={{ minWidth: 100, borderRadius: 20 }}
                                    >
                                        Comment
                                    </Button>

                                </>
                            )}
                        </Form.Item>
                    </Affix>
                </div>
            </div>

            {/* Modal Reject */}
            <Modal
                title="Write the reason"
                footer={null}
                visible={isModalVisible}
                onCancel={handleCancel}
            >
                <Form
                    name="rejectForm"
                    wrapperCol={{ span: 24 }}
                    initialValues={{ remember: true }}
                    onFinish={(values) => {
                        handleReject(values);
                        handleCancel();
                    }}
                    autoComplete="off"
                    layout="vertical"
                >
                    <Form.Item
                        name="message"
                        rules={[
                            {
                                required: true,
                                message: "Please input your Message!",
                            },
                            {
                                min: 50,
                                message: "Message must be at least 50 characters",
                            },
                        ]}
                    >
                        <Input.TextArea
                            showCount
                            style={{ height: "150px", width: "100%" }}
                            minLength={50}
                        />
                    </Form.Item>
                    <Form.Item className="mt-3" wrapperCol={{ span: 24 }}>
                        <Button type="primary" htmlType="submit" block>
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
            {/* Modal Cancel */}
            <Modal
                title="Write the reason"
                footer={null}
                visible={isCancelModalVisible}
                onCancel={handleCancelCancel}
            >
                <Form
                    name="cancelForm"
                    wrapperCol={{ span: 24 }}
                    initialValues={{ remember: true }}
                    onFinish={handleCancelSubmit}
                    autoComplete="off"
                    layout="vertical"
                >
                    <Form.Item
                        name="message"
                        rules={[
                            {
                                required: true,
                                message: "Please input your Message!",
                            },
                            {
                                min: 50,
                                message: "Message must be at least 50 characters",
                            },
                        ]}
                    >
                        <Input.TextArea
                            showCount
                            style={{ height: "150px", width: "100%" }}
                            minLength={50}
                        />
                    </Form.Item>
                    <Form.Item className="mt-3" wrapperCol={{ span: 24 }}>
                        <Button type="primary" htmlType="submit" block>
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
            {/* Modal Comment */}
            <Modal
                title="Write your comment"
                footer={null}
                visible={isCommentModalVisible}
                onCancel={handleCommentCancel}
            >
                <Form
                    name="commentForm"
                    wrapperCol={{ span: 24 }}
                    initialValues={{ remember: true }}
                    onFinish={(values) => {
                        handleComment(values);
                        handleCommentCancel();
                    }}
                    autoComplete="off"
                    layout="vertical"
                >
                    <Alert
                        message="Setiap komentar yang Anda posting akan mengirimkan notifikasi ke semua pihak yang terlibat dalam proses approval ini."
                        type="info"
                        showIcon
                        style={{ marginBottom: 16, fontSize: 12 }}
                    />
                    <Form.Item
                        name="message"
                        rules={[
                            {
                                required: true,
                                message: "Please input your comment!",
                            },
                        ]}
                    >
                        <Input.TextArea
                            showCount
                            style={{ height: "150px", width: "100%" }}
                            placeholder="Enter your comment here..."
                        />
                    </Form.Item>
                    <Form.Item className="mt-3" wrapperCol={{ span: 24 }}>
                        <Button type="primary" htmlType="submit" block>
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default ApprovalActions;
